import { masterAxios } from 'api/config'
import { Tenant } from 'types/tenant'
import { IS_IN_LOCAL, PORTAL_DOMAIN } from 'config'
import { store } from 'store/index'
import { settingsActions } from 'store/settings'

export const getTenantByDomain = async (domainUrl?: string | null | undefined) => {
  try {
    const { data } = await masterAxios.get<Tenant>('tenants/domain', {
      params: {
        domainUrl: IS_IN_LOCAL ? PORTAL_DOMAIN : domainUrl,
      },
    })
    store.dispatch(settingsActions.setTenantId(data._id))
    store.dispatch(settingsActions.setChatAttachmentsEnabled(!!data.tenantSetting?.chatAttachmentsEnabled))
    store.dispatch(settingsActions.setDisableAreaSelection(!!data.tenantSetting?.disableAreaSelection))
    return data
  } catch (e) {
    console.error({ e })
  }
}
